import { FC } from "react";
import { MessageThread } from "../../../core/types";
import ChatListItem from "./ChatListItem";
import { useTranslation } from "../../../contexts/useTranslation";

interface ChatListProps {
  messageThreads: MessageThread[];
  onClick: (messageThread: MessageThread) => void;
}

const ChatList: FC<ChatListProps> = ({ messageThreads, onClick }) => {
  const { translate } = useTranslation();

  if (messageThreads.length === 0) {
    return (
      <div className="flex items-center justify-center h-full text-center text-lastbot-on-surface md:max-w-[var(--lastbot-content-max-width)] md:w-full md:self-center">
        {translate("no_previous_conversations")}
      </div>
    );
  }

  return (
    <div className="md:max-w-[var(--lastbot-content-max-width)] md:w-full md:self-center">
      {messageThreads.map((messageThread, i) => (
        <ChatListItem
          key={messageThread.id}
          bordered={i !== messageThreads.length - 1}
          messageThread={messageThread}
          onClick={onClick}
        />
      ))}
    </div>
  );
};

export default ChatList;
